// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1RIvF","label":"Labeled_label__1wP0b","divider":"Labeled_divider__30BLA"};